
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireced6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireced6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("fGjqO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("JSq6p").then(()=>parcelRequire("50i7i"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


var $f1f9b7c3604aa354$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.226506d4.js","JSq6p","webfontloader.56fcc279.js"]'));

class $0ccbd4977765986b$export$60332b2344f7fe41 {
    constructor(game, config, onSwipe, cardIndex){
        this.dragStart = null;
        this.rotation = 0;
        this.maxRotation = 10;
        this.swiping = false;
        this.game = game;
        this.config = config;
        this.createCardElement();
        this.onSwipe = onSwipe;
        this.cardIndex = cardIndex;
    }
    release() {
        if (this.swiping) return;
        this.card.classList.remove("cursor-grabbing");
        this.card.classList.add("hover:cursor-grab");
        this.dragStart = null;
        if (Math.abs(this.rotation) > this.maxRotation / 2) {
            this.swipe();
            return;
        }
        this.card.style.transform = "";
        this.indicator.style.opacity = "0%";
    }
    swipe() {
        this.swiping = true;
        const direction = this.rotation > 0 ? "like" : "dislike";
        // this.game.cardContainer.removeChild(this.card);
        if (direction === "like") this.card.classList.add("animate-totheleft");
        if (direction === "dislike") this.card.classList.add("animate-totheright");
        if (this.config.points) {
            const points = this.config.points[direction];
            this.game.addPoints(points);
        }
        let rightAnswer = undefined;
        if (this.config.answer) {
            if (direction === this.config.answer) {
                this.game.addPoints(1);
                rightAnswer = true;
            } else {
                this.game.loseLife();
                rightAnswer = false;
            }
        }
        this.game.playerData.swipes.push({
            card: this.toString(),
            swipe: direction,
            rightAnswer: rightAnswer
        });
        this.onSwipe();
    }
    destroy() {
        this.card.remove();
    }
    toString() {
        let string = "";
        if (this.config.question) string += this.config.question + " - ";
        string += this.config.title;
        return string;
    }
    createCardElement() {
        this.card = document.createElement("div");
        this.card.className = "flex flex-col w-full h-full overflow-hidden absolute hover:cursor-grab touch-none";
        this.card.style.border = `${this.game.config.cardBorderWidth}px solid ${this.game.config.cardBorderColor}`;
        this.card.style.backgroundColor = `${this.game.config.cardColor}`;
        this.card.style.borderRadius = `${this.game.config.cardBorderRadius}px`;
        let img = document.createElement("div");
        img.className = "h-full w-full bg-center bg-cover bg-no-repeat relative";
        img.style.padding = this.game.config.indicatorPadding + "px";
        img.style.backgroundImage = `url(${this.config.image})`;
        img.style.backgroundColor = "black";
        this.indicator = document.createElement("div");
        this.indicator.className = "aspect-square rounded-full flex items-center justify-center absolute text-black";
        this.indicator.style.width = this.game.config.indicatorWidth + "px";
        this.indicatorText = document.createElement("div");
        this.indicatorText.style.fontSize = `${this.game.config.indicatorWidth / 4}px`;
        this.indicator.appendChild(this.indicatorText);
        img.appendChild(this.indicator);
        this.indicatorImage = document.createElement("img");
        this.indicatorImage.className = "absolute";
        this.indicatorImage.style.width = this.game.config.indicatorWidth + "px";
        this.indicator.appendChild(this.indicatorImage);
        this.card.appendChild(img);
        if (this.game.config.showCardTitle) {
            let title = document.createElement("div");
            title.className = "p-2";
            title.innerHTML = this.config.title.replaceAll("_", " ");
            this.card.appendChild(title);
        }
        this.card.addEventListener("pointerdown", (e)=>{
            if (!this.game.playing || this.game.getCurrentIndex() !== this.cardIndex) return;
            this.dragStart = e.pageX;
            this.card.classList.remove("hover:cursor-grab");
            this.card.classList.add("cursor-grabbing");
        });
        this.card.addEventListener("pointerup", (e)=>{
            if (!this.game.playing || this.game.getCurrentIndex() !== this.cardIndex) return;
            if (this.dragStart) this.release();
        });
        document.body.addEventListener("pointerleave", (e)=>{
            if (!this.game.playing || this.game.getCurrentIndex() !== this.cardIndex) return;
            if (this.dragStart) {
                this.rotation = this.rotation > 0 ? this.maxRotation / 2 + 1 : -this.maxRotation / 2 - 1;
                this.release();
            }
        });
        this.card.addEventListener("pointermove", (e)=>{
            e.preventDefault();
            if (!this.game.playing || this.game.getCurrentIndex() !== this.cardIndex) return;
            if (!this.dragStart) return;
            const dragDelta = e.pageX - this.dragStart;
            this.rotation = Math.round(dragDelta / 10);
            if (this.rotation > 0 && this.rotation > this.maxRotation) this.rotation = this.maxRotation;
            else if (this.rotation < 0 && this.rotation < -this.maxRotation) this.rotation = -this.maxRotation;
            this.card.style.transform = `translateX(${dragDelta}px) rotate(${this.rotation}deg)`;
            this.setIndicatorStyle();
        });
        this.game.cardContainer.appendChild(this.card);
    }
    setIndicatorStyle() {
        const direction = this.rotation > 0 ? "right" : "left";
        this.indicator.style.opacity = Math.pow(Math.abs(this.rotation) / this.maxRotation, 2) * 100 + "%";
        let img;
        if (direction === "left") {
            this.indicator.style.left = "unset";
            this.indicator.style.right = this.game.config.indicatorPadding + "px";
            img = this.game.config.swipeLeftIndicatorImage;
        } else {
            this.indicator.style.right = "unset";
            this.indicator.style.left = this.game.config.indicatorPadding + "px";
            img = this.game.config.swipeRightIndicatorImage;
        }
        if (img === "false") {
            this.indicatorImage.hidden = true;
            return;
        }
        if (img) {
            this.indicator.style.backgroundColor = "transparent";
            this.indicatorImage.hidden = false;
            this.indicatorImage.src = img;
            this.indicatorImage.style.top = "0";
            this.indicatorText.innerHTML = "";
            if (direction === "left") {
                this.indicatorImage.style.right = "0";
                this.indicatorImage.style.left = "unset";
                return;
            }
            this.indicatorImage.style.left = "0";
            this.indicatorImage.style.right = "unset";
            return;
        }
        this.indicatorImage.hidden = true;
        this.indicator.style.backgroundColor = direction === "left" ? "red" : "green";
        this.indicatorText.innerHTML = direction === "left" ? "NEE" : "JA";
    }
}


// Message to the platform

class $22f5f922ddc3e706$export$2dffd0b5373a4389 {
    constructor(){
        this.game = undefined;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    receive(data) {
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            case "play":
                this.game.play(); // Send play message to the game
                break;
            case "restart":
                this.game.restart();
        }
    }
    init(game, config) {
        this.game = game;
        // Load fonts and then send ready event
        let fonts = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = "" + v;
            if (key.toLowerCase().includes("font") && !fonts.includes(value) && !$22f5f922ddc3e706$var$excludedFonts.includes(value)) fonts.push(value);
        }
        if (fonts.length > 0) (parcelRequire("fGjqO")).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                // this.ready();
                }
            });
        });
    // } else {
    //   this.ready();
    // }
    }
    /**
   * Retrieve play event when game actualy starts
   */ gamestarted() {
        this.sendEvent({
            eventName: "start"
        });
    }
    play() {
        this.game?.play();
    }
    /**
   * Retrieve gameover event from game whith endsoce
   */ gameover(score, uitslag, custom) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: score,
                uitslag: uitslag,
                custom: custom
            }
        });
    }
    /**
   * Receive ready event from game when allowed to use start
   */ ready() {
        this.sendEvent({
            eventName: "ready"
        });
    }
    playSound(sound) {
        if (sound) this.sendEvent({
            eventName: "sound",
            data: this.game.config.path + "/" + sound
        });
    }
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    /**
   * Send message to the game platform
   * @param event
   */ sendEvent(event) {
        window?.parent?.postMessage(event, "*");
    }
    sendScore(score) {
        this.sendEvent({
            eventName: "score",
            data: score
        });
    }
    sendProgress(progress) {
        this.sendEvent({
            eventName: "progress",
            data: progress
        });
    }
    sendTimeleft(time) {
        this.sendEvent({
            eventName: "timeleft",
            data: time
        });
    }
    sendLives(lives) {
        this.sendEvent({
            eventName: "lives",
            data: lives
        });
    }
}
const $22f5f922ddc3e706$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


class $37465c1b8ae3a0af$export$129163f547cade8e {
    constructor(){
        this.swipes = [];
        this.score = 0;
        this.uitslag = "";
    }
}


class $25326d3c4d4e80b0$export$8fdcabde73f49165 {
    constructor(game, score, configs){
        this.game = game;
        if (configs.length === 0) return;
        if (configs.length > 0) this.config = configs[0];
        if (this.game.config.randomResult) {
            const random = Math.round(Math.random() * (configs.length - 1));
            this.config = configs[random];
        } else for(let i = 0; i < configs.length; i++){
            const u = configs[i];
            if (score >= u.min && score <= u.max) this.config = u;
        }
        if (!this.config) return;
    // this.createCardElement();
    }
    toString() {
        let string = "";
        if (this.config.title) string += this.config.title;
        if (this.config.text) {
            if (string !== "") string += " - ";
            string += this.config.text;
        }
        return string;
    }
}


function $a0f1153633232d54$export$448332262467e042(array) {
    let currentIndex = array.length, randomIndex;
    // While there remain elements to shuffle.
    while(currentIndex > 0){
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
        ];
    }
    return array;
}
function $a0f1153633232d54$export$ab82360ed81b09b9(s) {
    return /\d/.test(s);
}


class $7b066675d1aa79fa$export$38561bd03c7f0220 {
    constructor(config){
        this.firstGame = true;
        this.playing = false;
        this.playerData = new (0, $37465c1b8ae3a0af$export$129163f547cade8e)();
        this.cards = [];
        this.currentCard = 0;
        this.questionHeight = 0;
        this.platform = new (0, $22f5f922ddc3e706$export$2dffd0b5373a4389)();
        this.config = config;
        this.init();
    }
    getElement(name) {
        return document.getElementById(name);
    }
    init() {
        document.body.style.fontSize = this.config.fontSize + "px";
        document.body.style.color = this.config.fontColor;
        this.gameScreen = this.getElement("game-screen");
        this.cardContainer = this.getElement("card-container");
        this.cardContainer.style.backgroundColor = this.config.cardContainerColor;
        this.cardContainer.style.borderRadius = this.config.cardBorderRadius + "px";
        this.questionElement = this.getElement("question");
        if (!this.config.showQuestion) this.questionElement.remove();
        this.restart();
        this.platform.init(this, this.config);
        this.platform.preloadSounds(this.config);
    }
    setQuestion() {
        if (!this.config.showQuestion) return;
        const index = this.getCurrentIndex();
        if (index < 0) return;
        const card = this.cards[index];
        let question = this.config.question;
        if (card && card.config.question) question = card.config.question;
        this.questionElement.innerHTML = `<div>${question.replaceAll("\n", "<br/>")}</div>`;
    }
    getCurrentIndex() {
        return this.cards.length - this.currentCard - 1;
    }
    onSwipe() {
        this.platform.playSound(this.config.swipeSound);
        this.currentCard += 1;
        this.setProgressBarWidth();
        this.setQuestion();
        if (this.currentCard >= this.cards.length) this.goToResult();
    }
    play() {
        if (this.playing) return;
        this.playing = true;
        if (this.timeLeft) this.timeBarInterval = setInterval(()=>{
            this.timePassed(50);
        }, 50);
        this.platform.gamestarted();
    }
    loseLife() {
        this.platform.playSound(this.config.wrongAnswerSound);
        if (!this.lives) return;
        this.lives -= 1;
        this.platform.sendLives(this.lives);
        if (this.lives === 0) this.goToResult();
    }
    goToResult() {
        this.firstGame = false;
        this.playing = false;
        clearInterval(this.timeBarInterval);
        if (this.config.results.length === 0) {
            this.platform.gameover(this.playerData.score, "", JSON.stringify(this.playerData));
            return;
        }
        const result = new (0, $25326d3c4d4e80b0$export$8fdcabde73f49165)(this, this.playerData.score, this.config.results);
        this.playerData.uitslag = result.toString();
        // this.playerData.uitslag = result.config
        this.platform.gameover(this.playerData.score, result.config, JSON.stringify(this.playerData));
    }
    restart() {
        this.questionHeight = 0;
        this.cards.forEach((card)=>{
            card.destroy();
        });
        this.cards = [];
        this.playerData = new (0, $37465c1b8ae3a0af$export$129163f547cade8e)();
        this.lives = this.config.lives;
        if (this.lives) this.platform.sendLives(this.lives);
        this.timeLeft = this.config.timeLimit;
        if (this.config.shuffleCards) this.config.cards = (0, $a0f1153633232d54$export$448332262467e042)(this.config.cards);
        this.toggleVisible(this.gameScreen, true);
        if (this.config.showQuestion) this.questionHeight = Math.max(this.questionHeight, this.createQuestionElement(this.config.question));
        for(let i = 0; i < this.config.cards.length; i++){
            if (this.config.cardLimit && i >= this.config.cardLimit) break;
            const card = this.config.cards[i];
            this.cards.push(new (0, $0ccbd4977765986b$export$60332b2344f7fe41)(this, card, ()=>this.onSwipe(), i));
            if (this.config.showQuestion) this.questionHeight = Math.max(this.questionHeight, this.createQuestionElement(card.question));
        }
        this.questionElement.style.height = `${this.questionHeight}px`;
        this.currentCard = 0;
        this.setProgressBarWidth();
        this.setQuestion();
        this.platform.ready();
    }
    createQuestionElement(question) {
        if (!question) return 0;
        const questionElement = document.createElement("div");
        questionElement.className = "text-center opacity-0 w-full absolute";
        questionElement.innerHTML = question.replaceAll("\n", "<br/>");
        this.questionElement.appendChild(questionElement);
        return questionElement.clientHeight;
    }
    setProgressBarWidth() {
        const width = Math.round((this.currentCard + 1) / (this.cards.length + 1) * 100);
        this.platform.sendProgress(width);
    }
    timePassed(time) {
        if (!this.timeLeft || !this.config.timeLimit) return;
        this.timeLeft = this.timeLeft - time;
        this.platform.sendTimeleft(this.timeLeft / this.config.timeLimit * 100);
        if (this.timeLeft <= 0) this.goToResult();
    // this.timeBarElement.style.width = `${
    // 	(this.timeLeft / this.config.timeLimit) * 100
    // }%`;
    }
    toggleVisible(element, visible) {
        if (!element) return;
        element.style.opacity = visible ? "100%" : "0";
        element.style.pointerEvents = visible ? "all" : "none";
    }
    addPoints(points) {
        this.platform.playSound(this.config.rightAnswerSound);
        this.playerData.score += points;
        this.platform.sendScore(this.playerData.score);
    // this.scoreElement.innerHTML = this.playerData.score
    // 	.toString()
    // 	.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
}



var $3bfdb7183e8721d6$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $cfae44f0dfdf62c0$exports.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
$3bfdb7183e8721d6$exports = $3bfdb7183e8721d6$var$posix;


const $e45ba02351190ebe$export$de29564508b632b2 = {
    path: "https://mediadev.playsome.nl/games/swipegame/wietse_test/",
    randomize: "true",
    gamemode: "tinder",
    showCardTitle: "false",
    resultPath: "",
    revealResultText: "Tik hier!!!",
    question: "",
    cardBorderColor: "white",
    cardBorderWidth: 0,
    cardBorderRadius: 0,
    cardColor: "white",
    indicatorWidth: 75,
    indicatorPadding: 10,
    showQuestion: "true",
    results: ""
};
class $e45ba02351190ebe$export$f807d9a22ff8372d {
    async init(settings) {
        let cards;
        switch(settings.gamemode){
            case "quiz":
            case "kennisquiz":
                if (settings.cards) cards = settings.cards;
                else cards = await this.getCardsFromApi(settings.path, [
                    "goed",
                    "fout"
                ]);
                break;
            case "test":
            case "persquiz":
                cards = this.getCardsFromString(settings.cards, settings.path).reverse();
                break;
            case "tinder":
            case "enquete":
                if (settings.cards) cards = settings.cards;
                else cards = await this.getCardsFromApi(settings.path);
                break;
            default:
                cards = [];
        }
        const resultPath = settings.resultPath;
        const config = {
            path: settings.path,
            cards: cards,
            question: settings.question,
            showQuestion: settings.showQuestion === "true",
            results: this.getResults(settings.results, settings.path + "/" + resultPath),
            shuffleCards: settings.shuffleCards === "true",
            showCardTitle: settings.showCardTitle === "true",
            lives: settings.lives ? +settings.lives : undefined,
            timeLimit: settings.timeLimit ? +settings.timeLimit : undefined,
            cardLimit: +settings.cardLimit || undefined,
            randomResult: settings.randomResult === "true",
            resultPath: resultPath,
            font: "Montserrat",
            rightAnswerSound: settings.rightAnswerSound,
            wrongAnswerSound: settings.wrongAnswerSound,
            swipeSound: settings.swipeSound,
            fontColor: settings.fontColor,
            fontSize: settings.fontSize,
            cardContainerColor: settings.cardContainerColor,
            cardBorderColor: settings.cardBorderColor,
            cardBorderWidth: settings.cardBorderWidth,
            cardBorderRadius: settings.cardBorderRadius,
            cardColor: settings.cardColor,
            swipeLeftIndicatorImage: settings.swipeLeftIndicatorImage,
            swipeRightIndicatorImage: settings.swipeRightIndicatorImage,
            indicatorPadding: settings.indicatorPadding,
            indicatorWidth: settings.indicatorWidth
        };
        const cardSrcs = config.cards.map((c)=>c.image);
        const resultSrcs = config.results.map((r)=>r.image);
        let imgs = [
            ...cardSrcs
        ];
        if (resultSrcs.length > 0) imgs = imgs.concat(resultSrcs);
        if (config.swipeLeftIndicatorImage && config.swipeLeftIndicatorImage !== "false") {
            config.swipeLeftIndicatorImage = (0, (/*@__PURE__*/$parcel$interopDefault($3bfdb7183e8721d6$exports))).join(config.path, config.swipeLeftIndicatorImage);
            imgs.push(config.swipeLeftIndicatorImage);
        }
        if (config.swipeRightIndicatorImage && config.swipeRightIndicatorImage !== "false") {
            config.swipeRightIndicatorImage = (0, (/*@__PURE__*/$parcel$interopDefault($3bfdb7183e8721d6$exports))).join(config.path, config.swipeRightIndicatorImage);
            imgs.push(config.swipeRightIndicatorImage);
        }
        this.preloadImages(imgs).then(()=>{
            new (0, $7b066675d1aa79fa$export$38561bd03c7f0220)(config);
        });
    }
    async preloadImages(sources) {
        return new Promise((resolve)=>{
            let loadedCounter = 0;
            sources.forEach((src)=>{
                const image = new Image();
                image.onload = ()=>{
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.onerror = ()=>{
                    console.error(src + " was not found");
                    loadedCounter += 1;
                    if (loadedCounter === sources.length) resolve();
                };
                image.src = src;
            });
        });
    }
    getResults(resultsString, path) {
        let resultConfigs = [];
        if (resultsString.length === 0) return [];
        let splitBy = ",";
        if (resultsString.includes("|")) splitBy = "|";
        const results = resultsString.split(";");
        results.forEach((u, i)=>{
            let min;
            let max;
            let img;
            let title;
            let text;
            const split = u.split(splitBy);
            if (!(0, $a0f1153633232d54$export$ab82360ed81b09b9)(u)) {
                min = 0;
                max = 0;
                img = split[0];
                title = split[1];
                if (split.length > 2) text = split[2];
            } else {
                if (i === 0) {
                    min = -99999;
                    max = split[0];
                    img = split[1];
                    title = split[2];
                } else if (i + 1 === results.length) {
                    max = 99999;
                    min = split[0];
                    img = split[1];
                    title = split[2];
                } else {
                    const splitMinMax = split[0].split("-");
                    min = splitMinMax[0];
                    max = splitMinMax[1];
                    img = split[1];
                    title = split[2];
                }
            }
            // if (title.trim() === "") title = undefined;
            if (split.length > 3) text = split[3];
            resultConfigs.push({
                min: +min,
                max: +max,
                image: path + "/" + img,
                title: title,
                text: text
            });
        });
        return resultConfigs;
    }
    async getCardsFromApi(rootPath, subPaths) {
        const apiUrl = "http://192.168.178.94:5123";
        if (!apiUrl) return [];
        const split = rootPath.split("/games/");
        const root = split[0];
        const folder = split[1];
        let call = "";
        if (subPaths) call = `?root=${this.slashToPlus(folder)}&goed=${this.slashToPlus(subPaths[0])}&fout=${this.slashToPlus(subPaths[1])}`;
        else call = `?path=${this.slashToPlus(folder)}`;
        let cardsJson = await (await fetch(apiUrl + call, {
            mode: "cors"
        })).json();
        let cards = cardsJson.map((card)=>{
            return {
                image: card.image.replace("/media", root),
                title: card.title,
                answer: card.answer
            };
        });
        return cards;
    }
    slashToPlus(s) {
        return s.replaceAll("/", "+");
    }
    getCardsFromString(cardsString, path) {
        const cards = cardsString.split(";");
        const cardConfigs = [];
        let splitBy = ",";
        if (cardsString.includes("|")) splitBy = "|";
        cards.forEach((cardString)=>{
            const split = cardString.split(splitBy);
            let cardConfig = {
                image: "",
                title: ""
            };
            if (split.length >= 3) {
                const name = split[0].trim();
                const likePoints = +split[1].trim();
                const dislikePoints = +split[2].trim();
                if (isNaN(likePoints) || isNaN(dislikePoints)) {
                    console.error(cardString + " contains a number that is NaN");
                    cardConfig = {
                        image: path + name,
                        title: name.split(".")[0].replaceAll("_", " ")
                    };
                } else cardConfig = {
                    image: path + name,
                    title: name.split(".")[0].replaceAll("_", " "),
                    points: {
                        like: +likePoints,
                        dislike: +dislikePoints
                    }
                };
            }
            if (split.length >= 4) cardConfig.question = split[3].trim();
            cardConfigs.push(cardConfig);
        });
        return cardConfigs;
    }
    constructor(){
        this.cards = [];
    }
}


const $ad2bcec7a0192558$var$customConfig = $ad2bcec7a0192558$var$getSettingsFromURI(location.search);
let $ad2bcec7a0192558$var$config = (0, $e45ba02351190ebe$export$de29564508b632b2);
if ($ad2bcec7a0192558$var$customConfig) for (const [key, value] of Object.entries($ad2bcec7a0192558$var$customConfig))$ad2bcec7a0192558$var$config[key] = value;
const $ad2bcec7a0192558$var$configurator = new (0, $e45ba02351190ebe$export$f807d9a22ff8372d)();
$ad2bcec7a0192558$var$configurator.init($ad2bcec7a0192558$var$config);
function $ad2bcec7a0192558$var$getSettingsFromURI(uri) {
    let settingString;
    const split = uri.split("&");
    for (let s of split)if (s[0] === "s") settingString = decodeURIComponent(escape(atob(s.split("=")[1])));
    if (settingString === undefined) return null;
    let jsonString = "{";
    let settings = settingString.split("\n");
    settings.forEach((s)=>{
        const keyAndValue = s.split("=");
        if (keyAndValue.length === 1) return;
        const key = keyAndValue[0].trim();
        const value = keyAndValue[1].trim();
        if (value === "default") return;
        let line = '"' + key.toString() + '": ';
        if (value.includes("[") && value.includes("]")) line += value.toString();
        else line += '"' + value.toString() + '"';
        if (settings.indexOf(s) < settings.length - 1) line += ",";
        jsonString += line;
    });
    jsonString += "}";
    return JSON.parse(jsonString);
}


//# sourceMappingURL=index.226506d4.js.map
